import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, LayoutGrid, MessageCircle, FileText, Bell, Menu } from "lucide-react";
import { usePatientShellChrome } from "./patientShellChrome";
import "./PatientBottomNav.scss";

const ICON = 20;
const STROKE = 2;

function isTabActive(to, pathname) {
  const p = (pathname || "/").replace(/\/$/, "") || "/";
  if (to === "/HealBidDashboard") return p === "/HealBidDashboard";
  if (to === "/patient-requests") {
    return (
      p === "/patient-requests" ||
      pathname.startsWith("/request/")
    );
  }
  if (to === "/patient-chats") return pathname.startsWith("/patient-chats");
  if (to === "/patient-documents") return pathname.startsWith("/patient-documents");
  if (to === "/patient-notifications") return pathname.startsWith("/patient-notifications");
  if (to === "/patient-profile") return p === "/patient-profile" || pathname.startsWith("/patient-profile/");
  return false;
}

/** Shorter visible labels on the fixed bar avoid truncation on narrow phones; aria-label keeps names clear for AT. */
const tabs = [
  { to: "/HealBidDashboard", label: "Home", ariaLabel: "My care", end: true },
  { to: "/patient-requests", label: "List", ariaLabel: "Your care list" },
  { to: "/patient-chats", label: "Chats", ariaLabel: "Messages" },
  { to: "/patient-documents", label: "Docs", ariaLabel: "Documents" },
  { to: "/patient-notifications", label: "Alerts", ariaLabel: "Notifications" },
  { to: "/patient-profile", label: "Menu", ariaLabel: "Account menu — profile, policies, and settings" },
];

const iconByTo = {
  "/HealBidDashboard": Home,
  "/patient-requests": LayoutGrid,
  "/patient-chats": MessageCircle,
  "/patient-documents": FileText,
  "/patient-notifications": Bell,
  "/patient-profile": Menu,
};

export default function PatientBottomNav() {
  const { pathname } = useLocation();
  const { chromeScrollHidden } = usePatientShellChrome();
  const scrollHidden = chromeScrollHidden;

  const hide =
    /^\/Login$/i.test(pathname) ||
    /^\/Signup$/i.test(pathname) ||
    /^\/verify-otp$/i.test(pathname);

  if (hide) return null;

  return (
    <nav
      className={`patient-bottom-nav${scrollHidden ? " patient-bottom-nav--scroll-hidden" : ""}`.trim()}
      aria-label="Main"
      aria-hidden={scrollHidden ? true : undefined}
    >
      <div className="patient-bottom-nav__inner">
        {tabs.map((tab) => {
          const Icon = iconByTo[tab.to];
          return (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={Boolean(tab.end)}
              aria-label={tab.ariaLabel ?? tab.label}
              title={tab.ariaLabel ?? tab.label}
              className={() =>
                `patient-bottom-nav__item${isTabActive(tab.to, pathname) ? " patient-bottom-nav__item--active" : ""}`
              }
            >
              <span className="patient-bottom-nav__icon" aria-hidden>
                <Icon size={ICON} strokeWidth={STROKE} />
              </span>
              <span className="patient-bottom-nav__label">{tab.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
